export const isQaEnv = (): boolean => {
    return window.location.hostname.includes('backofficeqa')
}
